module.exports = __webpack_public_path__ + "img/m1.ac8236db.jpg";